import { render, staticRenderFns } from "./TextareaInput.vue?vue&type=template&id=45ff18fe&scoped=true&"
import script from "./TextareaInput.vue?vue&type=script&lang=js&"
export * from "./TextareaInput.vue?vue&type=script&lang=js&"
import style0 from "./TextareaInput.vue?vue&type=style&index=0&id=45ff18fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ff18fe",
  null
  
)

export default component.exports